import { capturedGet, capturedPost, capturedRemove, capturedPut } from '../../http'
import { createModule } from '@/global/store/modules/channel'

export default createModule('agency', { capturedGet, capturedPost, capturedRemove, capturedPut })
